import 'core-js/stable'
import 'regenerator-runtime/runtime'

import { createApp } from 'vue'
import { setUpI18n } from 'tbk-utils/i18n'

import VueScrollTo from 'vue-scrollto'
import _ from 'lodash'

import ActivityApp from 'embeds/activity/activity-app'

window._ = _

window.initActivityApp = function(options) {
  const i18n = setUpI18n(options.translations)
  if (options.translations) {
    delete options.translations
  }

  const app = createApp(ActivityApp)
  app.use(i18n)
  app.use(VueScrollTo)

  // provide options
  app.provide('options', options)
  app.provide('configuration', options.configuration)

  // finally mount the app
  app.mount(options.bind_element)

}
